(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sec-home-futuredin"] && !window.DesignMode) return;
  try {
    
function isMobile() {
  return window.innerWidth <= 768;
}

function addButtonForMobile() {
  if (isMobile()) {
    const div = document.querySelector('.home-hero-marquee');
    if (div && !div.querySelector('button.mobile-button')) {
      // Create a button element
      const button = document.createElement('button');
      button.innerText = 'Learn More';
      button.classList.add('mobile-button'); // Add a class for styling if needed
      // Append the button to the div
      div.appendChild(button);

      button.addEventListener('click', function() {
        div.classList.toggle('open');
      });
    }
  }
}

// Run the function when the page loads
window.onload = addButtonForMobile;

// Run the function when the window is resized (optional)
window.onresize = addButtonForMobile;

jQuery('.sec-futuredin ul').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  autoplay: true,
  infinite: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-home-recipes"] && !window.DesignMode) return;
  try {
    
jQuery('.recipes-list').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  infinite: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-home-reviews"] && !window.DesignMode) return;
  try {
    
jQuery(document).ready(function(){
  jQuery('.reviews_list').slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
});

  } catch(e) { console.error(e); }
})();
})();
